import { render, staticRenderFns } from "./ShowDisplaySize.vue?vue&type=template&id=7835ce5c&scoped=true"
import script from "./ShowDisplaySize.vue?vue&type=script&lang=js"
export * from "./ShowDisplaySize.vue?vue&type=script&lang=js"
import style0 from "./ShowDisplaySize.vue?vue&type=style&index=0&id=7835ce5c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7835ce5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7835ce5c')) {
      api.createRecord('7835ce5c', component.options)
    } else {
      api.reload('7835ce5c', component.options)
    }
    module.hot.accept("./ShowDisplaySize.vue?vue&type=template&id=7835ce5c&scoped=true", function () {
      api.rerender('7835ce5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShowDisplaySize.vue"
export default component.exports